import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=f18be67c&"
import script from "./phoneNumber.vue?vue&type=script&lang=js&"
export * from "./phoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports